import { FC, ReactNode } from "react";
import { Tickets } from "./Tickets";
import styles from "./TicketsPanel.module.scss";
import { IUserBalances } from "../../model/user-info.interface";
import { TicketsPanelContext } from "./Ticket";

interface ITicketsPanelProps extends Partial<IUserBalances> {
    context?: TicketsPanelContext;
    prefix?: string;
    background?: boolean;
    label?: ReactNode;
    precission?: number;
}

export const TicketsPanel: FC<ITicketsPanelProps> = ({ prefix, context, label, background = false, precission, ...tickets }) => {
    return (
        <div className={`${styles.ticketsWrapper} ${background ? styles.background : ''}`} >
            { label }            
            <Tickets
                { ...tickets }
                prefix={prefix}
                context={context}
                precission={ precission }
            />
        </div>
    );
}